import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingPage from './LandingPage';
import HomePage from './HomePage';

const RootPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  useEffect(() => {
    if (token && user) {
      try {
        const parsedUser = JSON.parse(user);
        // Check if there's a stored redirect path (e.g., from meeting booking)
        const storedRedirect = localStorage.getItem('authRedirectPath');
        
        // Only redirect if there's a stored redirect path
        // Don't auto-redirect based on role - let users access both views
        if (storedRedirect) {
          const redirectPath = storedRedirect;
          localStorage.removeItem('authRedirectPath');
          navigate(redirectPath, { replace: true });
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, [token, user, navigate]);

  if (token && user) {
    try {
      // User is logged in - show guest homepage
      // They can switch to host view via navbar
      return <HomePage />;
    } catch (error) {
      // If there's an error parsing user data, show landing page
      return <LandingPage />;
    }
  }
  
  return <LandingPage />;
};

export default RootPage;
